module.exports = __webpack_public_path__ + "ee4488c8d17d2e5789223a746cdfac9c.png";